import { render, staticRenderFns } from "./LPOTerms.vue?vue&type=template&id=c10a6868&"
import script from "./LPOTerms.vue?vue&type=script&lang=js&"
export * from "./LPOTerms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports